import type { MeldContext, MeldTaal, MisluktVerzoek } from './types';

/**
 * P6: the automatic context of a melding. The route keeps the NAMES of its
 * query parameters and never their values; a failed request keeps its path
 * without the query string. Both can otherwise carry a customer data value.
 */
const MAX_MISLUKT = 5;
const PARAM_NAAM = /^[A-Za-z0-9_.\-[\]]{1,40}$/;
// Qontrol meldingSchema (deel 03) and backend/meldingen/schemas.py refuse longer
// values and any "=" in a route or path. JS length/slice count UTF-16 units,
// the same unit the backend counts.
const MAX_ROUTE = 500;
const MAX_PAD = 300;
const MAX_BROWSER = 200;
const MAX_SCHERM = 20;

let mislukt: readonly MisluktVerzoek[] = [];

function zonderIs(pad: string): string {
  return pad.replace(/=/g, '%3D');
}

/** Called by lib/api.ts for every failed request. Keeps the last five. */
export function onthoudMislukking(methode: string, pad: string, status: number, requestId: string | null): void {
  const zonderQuery = pad.split(/[?#]/)[0] ?? '';
  const veilig = zonderIs(zonderQuery.startsWith('/') ? zonderQuery : `/${zonderQuery}`);
  const regel: MisluktVerzoek = {
    methode: methode.toUpperCase(),
    pad: veilig.slice(0, MAX_PAD),
    status,
    request_id: requestId ? requestId.slice(0, 100) : null,
  };
  mislukt = [...mislukt, regel].slice(-MAX_MISLUKT);
}

export function vergeetMislukkingen(): void {
  mislukt = [];
}

export function routeZonderWaarden(pathname: string, search: string): string {
  const namen = [...new Set(new URLSearchParams(search).keys())].filter((n) => PARAM_NAAM.test(n)).slice(0, 20);
  let route = zonderIs(pathname).slice(0, 400) || '/';
  for (const [i, naam] of namen.entries()) {
    const langer = `${route}${i === 0 ? '?' : '&'}${naam}`;
    if (langer.length > MAX_ROUTE) break;
    route = langer;
  }
  return route;
}

export function meldTaal(taal: string | undefined): MeldTaal | null {
  const kort = taal?.split('-')[0];
  return kort === 'nl' || kort === 'en' || kort === 'de' ? kort : null;
}

export interface Venster {
  location: { pathname: string; search: string };
  innerWidth: number;
  innerHeight: number;
  navigator: { userAgent: string };
}

export function bouwContext(w: Venster, taal: string | undefined, buildSha: string | undefined): MeldContext {
  return {
    route: routeZonderWaarden(w.location.pathname, w.location.search),
    build_sha: buildSha ? buildSha.slice(0, 64) : null,
    scherm: `${w.innerWidth}x${w.innerHeight}`.slice(0, MAX_SCHERM),
    browser: w.navigator.userAgent.slice(0, MAX_BROWSER),
    taal: meldTaal(taal),
    mislukte_verzoeken: [...mislukt],
  };
}
